export default __webpack_public_path__ + "static/media/star-outline-white.0c7e3b4a.svg";